import { bboxToCenter as R, computeBbox as b, distance as H, squaredDistance as d, sizeToResolution as v, doBboxesIntersect as O, bufferBboxByRatio as Y } from "@allmaps/stdlib";
function k(e, t, o, i) {
  let r = Number.POSITIVE_INFINITY, n = e.at(-1);
  for (const l of e) {
    const c = Math.abs(
      Math.log2(l.scaleFactor) - (Math.log2(t + o) + i)
    );
    c < r && (r = c, n = l);
  }
  return n;
}
function G(e, t, o) {
  const i = C(e, t), r = I(i), n = y(r, t, o), l = R(b(e));
  return n.sort(
    (c, s) => F(c, l) - F(s, l)
  ), n;
}
function C(e, t) {
  return e.map((o) => [
    o[0] / t.originalWidth,
    o[1] / t.originalHeight
  ]);
}
function I(e) {
  const t = {};
  for (let o = 0; o < e.length; o++) {
    const i = [e[o], e[(o + 1) % e.length]];
    V(i).forEach(([n, l]) => {
      t[n] || (t[n] = [Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY]), l < t[n][0] && (t[n][0] = l), l > t[n][1] && (t[n][1] = l);
    });
  }
  return t;
}
function V([e, t]) {
  let o = Math.floor(e[0]), i = Math.floor(e[1]);
  const r = Math.floor(t[0]), n = Math.floor(t[1]), l = [[o, i]];
  if (o === r && i === n)
    return l;
  const c = Math.sign(t[0] - e[0]), s = Math.sign(t[1] - e[1]), g = Math.abs(e[0] - o - Math.max(0, c)), u = Math.abs(e[1] - i - Math.max(0, s)), a = Math.abs(e[0] - t[0]), f = Math.abs(e[1] - t[1]);
  let h = g / a, m = u / f;
  const p = 1 / a, x = 1 / f;
  for (; !(o === r && i === n); )
    h < m ? (h = h + p, o = o + c) : (m = m + x, i = i + s), l.push([o, i]);
  return l;
}
function y(e, t, o) {
  const i = [];
  for (const r in e) {
    const n = parseInt(r);
    if (n < 0 || n >= t.columns)
      break;
    const l = Math.max(e[n][0], 0), c = Math.min(e[n][1], t.rows - 1);
    for (let s = l; s <= c; s++)
      i.push({
        column: n,
        row: s,
        tileZoomLevel: t,
        imageSize: o
      });
  }
  return i;
}
function w(e, t, o, i) {
  let r = Math.floor(
    e.column * e.tileZoomLevel.scaleFactor / o
  );
  r = r >= 0 ? r : 0;
  const n = Math.ceil(
    (e.column + 1) * e.tileZoomLevel.scaleFactor / o
  );
  let l = Math.floor(
    e.row * e.tileZoomLevel.scaleFactor / o
  );
  l = l >= 0 ? l : 0;
  const c = Math.ceil(
    (e.row + 1) * e.tileZoomLevel.scaleFactor / o
  );
  return B(
    o,
    t,
    r,
    n,
    l,
    c,
    i
  );
}
function B(e, t, o, i, r, n, l = (c) => !0) {
  const c = t.tileZoomLevels.find(
    (u) => u.scaleFactor == e
  ), s = [t.width, t.height];
  if (!c)
    return [];
  o = o || 0, i = i || c.columns, r = r || 0, n = n || c.rows;
  const g = [];
  for (let u = o; u < i; u++)
    for (let a = r; a < n; a++) {
      const f = {
        column: u,
        row: a,
        tileZoomLevel: c,
        imageSize: s
      };
      l(f) && g.push(f);
    }
  return g;
}
function K(e, t) {
  return e.column == t.column && e.row == t.row && e.tileZoomLevel.scaleFactor == t.tileZoomLevel.scaleFactor;
}
function E(e, t) {
  return H(M(e), t);
}
function F(e, t) {
  return d(M(e), t);
}
function M(e) {
  const t = S(e);
  return [(t[2] - t[0]) / 2 + t[0], (t[3] - t[1]) / 2 + t[1]];
}
function T(e) {
  return [
    e.column * e.tileZoomLevel.originalWidth,
    e.row * e.tileZoomLevel.originalHeight
  ];
}
function P(e, t) {
  const o = [t.tileZoomLevel.width, t.tileZoomLevel.height];
  return e.map((i, r) => (i = Math.max(i, 0), i = Math.min(i, o[r] - 1), i));
}
function j(e, t, o = !0) {
  const i = T(t), r = [
    (e[0] - i[0]) / t.tileZoomLevel.scaleFactor,
    (e[1] - i[1]) / t.tileZoomLevel.scaleFactor
  ];
  if (!o || N(e, t))
    return r;
}
function N(e, t) {
  const o = T(t);
  return e[0] >= o[0] && e[0] <= o[0] + t.tileZoomLevel.originalWidth && e[1] >= o[1] && e[1] <= o[1] + t.tileZoomLevel.originalHeight;
}
function J(e, t) {
  return e[0] > 0 && e[0] <= t.imageSize[0] && e[1] > 0 && e[1] <= t.imageSize[1];
}
function S(e) {
  const t = T(e), o = Math.min(
    t[0] + e.tileZoomLevel.originalWidth,
    e.imageSize[0]
  ), i = Math.min(
    t[1] + e.tileZoomLevel.originalHeight,
    e.imageSize[1]
  );
  return [
    t[0],
    t[1],
    o,
    i
  ];
}
function z(e) {
  return [e.tileZoomLevel.width, e.tileZoomLevel.height];
}
function X(e) {
  return [e.tileZoomLevel.originalWidth, e.tileZoomLevel.originalHeight];
}
function W(e) {
  return v(z(e));
}
function D(e) {
  return v(X(e));
}
function Q(e) {
  return e.map((t) => W(t)).reduce((t, o) => t + o, 0);
}
function ee(e) {
  return e.map((t) => D(t)).reduce((t, o) => t + o, 0);
}
function te(e) {
  return e.rows * e.width * e.columns * e.height;
}
function oe(e) {
  return e.rows * e.originalWidth * e.columns * e.originalHeight;
}
function ie(e, t, o, i, r, n) {
  const l = [], c = A(
    e,
    t,
    o,
    i,
    n
  );
  for (const s of c)
    s && l.push(s);
  if (l.length == 0) {
    const s = Z(
      e,
      t,
      o,
      r,
      n
    );
    s && l.push(s);
  }
  return l;
}
function Z(e, t, o, i, r) {
  const n = 2 ** (Math.log2(o) + 1);
  if (n > t.tileZoomLevels.map((c) => c.scaleFactor).reduce((c, s) => c + s, 0) - o || i == 0)
    return;
  const l = _(
    e,
    t,
    n,
    r
  );
  return l !== void 0 ? l : Z(
    e,
    t,
    n,
    i--,
    r
  );
}
function A(e, t, o, i, r) {
  const n = 2 ** (Math.log2(o) - 1);
  if (n <= 0 || i == 0)
    return [];
  const l = L(
    e,
    t,
    n,
    r
  ), c = L(
    e,
    t,
    n,
    (s) => !0
  );
  return l.length == c.length ? l : [
    ...l,
    ...A(
      e,
      t,
      n,
      i--,
      r
    )
  ];
}
function _(e, t, o, i) {
  const r = w(
    e,
    t,
    o,
    i
  );
  if (r.length != 0)
    return r[0];
}
function L(e, t, o, i) {
  return w(
    e,
    t,
    o,
    i
  );
}
function ne(e) {
  return $(e.mapId, e.tileUrl);
}
function $(e, t) {
  return `${e}:${t}`;
}
function re(e) {
  return q(
    e.tileZoomLevel.scaleFactor,
    e.row,
    e.column
  );
}
function q(e, t, o) {
  return `${e}:${t}:${o}`;
}
function le(e, t) {
  const o = t.getIiifTile(
    e.tileZoomLevel,
    e.column,
    e.row
  );
  return t.getImageUrl(o);
}
function ce(e, t, o) {
  if (t.overviewTileZoomLevelForViewport && e.tileZoomLevel.scaleFactor == t.overviewTileZoomLevelForViewport.scaleFactor)
    return !1;
  if (t.resourceViewportRingBboxForViewport == null || t.tileZoomLevelForViewport == null)
    return !0;
  const i = Math.log2(e.tileZoomLevel.scaleFactor) - Math.log2(t.tileZoomLevelForViewport.scaleFactor);
  return i > o.maxHigherLog2ScaleFactorDiff || -i > o.maxLowerLog2ScaleFactorDiff || !O(
    Y(
      S(e),
      Math.max(0, i)
    ),
    t.resourceViewportRingBboxForViewport
  );
}
export {
  P as clipTilePointToTile,
  S as computeBboxTile,
  G as computeTilesCoveringRingAtTileZoomLevel,
  E as distanceTileToPoint,
  K as equalTileByRowColumnScaleFactor,
  ne as fetchableTileKey,
  _ as getTileAtHigherScaleFactor,
  D as getTileOriginalResolution,
  X as getTileOriginalSize,
  W as getTileResolution,
  z as getTileSize,
  k as getTileZoomLevelForScale,
  oe as getTileZoomLevelOriginalResolution,
  te as getTileZoomLevelResolution,
  L as getTilesAtLowerScaleFactor,
  ie as getTilesAtOtherScaleFactors,
  B as getTilesAtScaleFactor,
  w as getTilesCoveringTileAtScaleFactor,
  ee as getTilesOriginalResolution,
  Q as getTilesResolution,
  $ as keyFromMapIdTileUrl,
  q as keyFromScaleFactorRowColumn,
  Z as recursivelyGetTilesAtHigherScaleFactor,
  A as recursivelyGetTilesAtLowerScaleFactor,
  J as resourcePointInImage,
  N as resourcePointInTile,
  j as resourcePointToTilePoint,
  ce as shouldPruneTile,
  F as squaredDistanceTileToPoint,
  M as tileCenter,
  re as tileKey,
  T as tileToTileOriginPoint,
  le as tileUrl
};
//# sourceMappingURL=tiles.js.map
